import { NavLink, Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/services", label: "Services", testid: "nav-services" },
  { to: "/book", label: "Book Now", testid: "nav-book" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-md bg-[var(--cream)]/85 border-b border-[var(--border-soft)]"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link
          to="/"
          className="group flex items-center gap-2"
          data-testid="nav-logo"
        >
          <span className="font-serif-display italic text-[1.45rem] md:text-[1.6rem] leading-none text-[var(--indigo)]">
            Legacy
          </span>
          <span className="font-serif-display text-[1.45rem] md:text-[1.6rem] leading-none text-[var(--indigo)] tracking-tight">
            Content Lab
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-[0.78rem] uppercase tracking-[0.22em] font-medium transition-colors duration-200 link-underline ${
                  isActive ? "text-[var(--gold)]" : "text-[var(--indigo)] hover:text-[var(--gold)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/book"
            className="btn-gold !py-3 !px-6 !text-[0.72rem]"
            data-testid="nav-cta-book"
          >
            Book a Session
          </Link>
        </nav>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-[var(--indigo)]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          className="md:hidden border-t border-[var(--border-soft)] bg-[var(--cream)]"
          data-testid="nav-mobile-menu"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`${l.testid}-mobile`}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.22em] font-medium ${
                    isActive ? "text-[var(--gold)]" : "text-[var(--indigo)]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/book"
              onClick={() => setOpen(false)}
              className="btn-gold mt-2 w-full"
              data-testid="nav-cta-book-mobile"
            >
              Book a Session
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
